module.exports = __webpack_public_path__ + "images/newerp_button3.1788921444950.png";